import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initNativeShell } from "@/lib/native";
import { initAnalytics } from "@/lib/analytics";

// Boot native shell tweaks (status bar + splash hide). No-op on web.
initNativeShell();
initAnalytics();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
